// EventLayout — category-based two-panel layout for event routes.
// Delegates to the shared CategoryLayout component.

import { CategoryLayout, useSelectedCategory } from '@/components/features/category-selection-tree'

// Re-export under the domain-specific name for backward compatibility
export { useSelectedCategory as useSelectedEventCategory }

export function EventLayout() {
  return (
    <CategoryLayout
      categoryType="event"
      domainPath="events"
      heading="Event Categories"
    />
  )
}
